<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      :title="title"
      width="800px"
      top="5vh"
  >
    <table-select
        :filter="filter"
        :columns="columns"
        module="basic"
        url="fm/calendarShift"
        @select="selectShift"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter">
          <el-form-item label="班次编码">
            <el-input v-model.trim="filter.shiftCode" placeholder="请输入班次编码" clearable/>
          </el-form-item>
          <el-form-item label="班次名称">
            <el-input v-model.trim="filter.shiftName" placeholder="请输入班次名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    name: "CalendarShiftSelect",
    components: { TableSelect },
    props: {
      title: {
        type: String,
        default: "选择班次",
      },
      filter: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        dialogVisible: false,
        columns: [
          { title: "班次编码", key: "shiftCode", width: 130, align: "center" },
          { title: "班次名称", key: "shiftName" },
          { title: "上班时间", key: "workStart", width: 100, align: "center" },
          { title: "下班时间", key: "workEnd", width: 100, align: "center" },
          { title: "操作", slot: "action", width: 80, align: "center" },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      selectShift(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
      resetHandle(filter) {
        this.$emit("reset", filter);
      },
    },
  };
</script>
